import styled from 'styled-components';
import { PlaceholderImageProps } from '.';

export const Container = styled.div<PlaceholderImageProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  padding: 12px;

  border-radius: 50%;

  background-color: #d6d7f54d;

  /* border-radius: 50%;
  width: 100px;
  height: 100px;
  background: black;
  opacity: 0.5;
  -webkit-filter: blur(10px);
  -webkit-transform: scale(1, 0.2); */
`;
